import { computed, Ref } from 'vue';
import { IUIState } from './models';
import { useRoute } from 'vue-router';
import { ROUTE_CHAT_ROOT, ROUTE_CHAT, ROUTE_CHAT_PROJECT } from '@/router/chat/routes';
import { LanguageCodes, USER_PREFERENCE_KEY_LANGUAGE } from '@/shared/constants';
import { AppPermissions } from '@/shared/permissions';
import usePermissionChecker from '@/core/composable/use-permission-checker';

const useStoreGetters = (state: Ref<IUIState>) => {
  const route = useRoute();
  const {hasPermission} = usePermissionChecker()

  const userLanguage = computed(
    () =>
      state.value.userPreferences.find((x) => x.preferenceKey === USER_PREFERENCE_KEY_LANGUAGE)?.preferenceValue ||
      LanguageCodes.it
  );

  const getDateFormat = computed(() => {
    switch (userLanguage.value) {
      case LanguageCodes.en:
      case 'en':
        return 'dd/MM/yyyy';
      case LanguageCodes.it:
      case 'it':
        return 'dd/MM/yyyy';
      default:
        return 'dd/MM/yyyy';
    }
  });

  const getDateTimeFormat = computed(() => {
    const dateFormat = getDateFormat.value;
    return `${dateFormat} HH:mm`;
  });

  const getFullDateTimeFormat = computed(() => {
    const dateFormat = getDateFormat.value;
    return `${dateFormat} HH:mm:ss.SSS`;
  });

  const isUserAdmin = computed(() => {
    return state.value.sessionUserInfo?.profileName?.toLowerCase() === 'admin';
  });

  const isRouteChat = computed(() => !!route.matched.find((x) => x.name == ROUTE_CHAT_ROOT));


  const canSeeProfiles = computed(() => hasPermission(AppPermissions.ProfilesRead));
  const canSeeChatbots = computed(() =>hasPermission(AppPermissions.ChatbotRead));
  const canEditProfiles = computed(() => hasPermission(AppPermissions.ProfilesWrite));

  return {
    isRouteChat,
    isUserAdmin,
    userLanguage,
    getDateFormat,
    canSeeProfiles,
    canSeeChatbots,
    canEditProfiles,
    getDateTimeFormat,
    getFullDateTimeFormat,
  };
};

export default useStoreGetters;
